// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2pQwI","right":"styles_right__1h1Eh"};